import * as Sentry from '@sentry/nextjs'
import { getSession } from 'next-auth/react'

import { EventName } from '@/constants/mixpanel'
import { identifyUser, trackEvent } from '@/utils/mixpanelClient'

/**
 * ログイン成功時にセッション情報を取得してMixpanelでユーザーを識別する
 * ログインフォーム（通常ログイン・アカウント切替ログイン）から共通で利用する
 * @param email ログインに使用したメールアドレス
 */
export const generateMixpanelUser = async (email: string) => {
  try {
    const session = await getSession()
    if (session?.user) {
      // ユーザーIDでMixpanelに識別情報を送信
      identifyUser(session.user.id || 'unknown', {
        name: session.user.username,
        email,
        login_method: 'credentials',
      })

      // ログインイベントを追跡
      trackEvent(EventName.UserLogin, {
        method: 'credentials',
        user_id: session.user.id,
        email,
      })
    }
  } catch (error) {
    // Mixpanelの識別に失敗してもログイン処理は継続
    // アナリティクスは補助的機能のため、ユーザー体験に影響させない
    Sentry.captureException(error, {
      tags: {
        // Mixpanel特有のコンテキスト情報追加
        feature: 'mixpanel',
        action: 'user_identification',
      },
      level: 'warning', // criticalではなくwarning
    })
  }
}
